import script from "./tab-pane.vue?vue&type=script&setup=true&lang=ts"
export * from "./tab-pane.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__